import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function _24mpIcon(props: IconProps) {
    return <Icon {...props} iconKey={"24mp"}/>
}
